import { createSlice } from "@reduxjs/toolkit";

const couponSlice = createSlice({
  name: "coupon",
  initialState: {
    data: [],          // List of coupons
    loading: false,
    coupon_info: {},
    error: null,
    total: 0, 
  },
  reducers: {
    // FETCH ALL
    fetchCouponsRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchCouponsSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload?.data || [];
      state.total = action.payload?.total || 0;
    },
    fetchCouponsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // CREATE
    createCouponRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    createCouponSuccess: (state, action) => {
      state.loading = false;
      state.data.push(action.payload);
    },
    createCouponFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // UPDATE
    updateCouponRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateCouponSuccess: (state, action) => {
      state.loading = false;
      const index = state.data.findIndex(coupon => coupon._id === action.payload._id);
      if (index !== -1) {
        state.data[index] = action.payload;
      }
    },
    updateCouponFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // DELETE
    deleteCouponRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    deleteCouponSuccess: (state, action) => {
      state.loading = false;
      state.data = state.data.filter(coupon => coupon._id !== action.payload);
    },
    deleteCouponFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
     getApplicableCouponsRequest: (state) => {
    state.loading = true;
    state.error = null;
  },
  getApplicableCouponsSuccess: (state, action) => {
     state.loading = false;
      state.coupon_info = action.payload;
  },
  getApplicableCouponsFailure: (state, action) => {
    state.loading = false;
    state.error = action.payload;
  },
   clearCouponError(state) {
    state.error = null; 
  },
  clearCouponInfo: (state) => { state.coupon_info = {}; },
  },
});

export const {
  fetchCouponsRequest,
  fetchCouponsSuccess,
  fetchCouponsFailure,
  createCouponRequest,
  createCouponSuccess,
  createCouponFailure,
  updateCouponRequest,
  updateCouponSuccess,
  updateCouponFailure,
  deleteCouponRequest,
  deleteCouponSuccess,
  deleteCouponFailure,
 getApplicableCouponsRequest,     
  getApplicableCouponsSuccess,     
  getApplicableCouponsFailure, 
  clearCouponError, 
  clearCouponInfo,
} = couponSlice.actions;

export { couponSlice };

export default couponSlice.reducer;
export const newdata=0;
